import * as React from "react";

import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";
import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";
import { Grid, Button, Divider, Container } from "semantic-ui-react";
import { Detail } from "@neworbit/simpleui-detail";
import Utils from "@teamprevent/common/utils";
import { useDispatch, useSelector } from "@teamprevent/customer-redux";

import { ApplicationState } from "../../applicationState";
import { loadActionableTask } from "../actions";
import { loadOhCaseDetail } from "../../crud/ohCase/actions";

import { InsufficientInformationActionForm } from "./InsufficientInformationActionForm";

export const InsufficientInformationDetail = () => {
    const dispatch = useDispatch();
    const ohCaseId = useSelector((state: ApplicationState) => state.router.params?.ohCaseId);
    const taskId = useSelector((state: ApplicationState) => state.router.params?.taskId);
    const actionableTask = useSelector((state: ApplicationState) => state.actionableTask);

    const enableEnhancedInsufficientInformationFunctionality = getFeatureToggles()[FeatureToggleNames.EnableEnhancedInsufficientInformationFunctionality];

    React.useEffect(() => {
        dispatch(loadActionableTask({ ohCaseId, taskId }));
        dispatch(loadOhCaseDetail({ ohCaseId }));
    }, [dispatch, ohCaseId, taskId]);

    const viewReferralFormButtonUrl = React.useMemo(() => {
        if (!actionableTask) {
            return "";
        }
        const url = `/ohCases/${actionableTask.ohCase.id}`;

        if (enableEnhancedInsufficientInformationFunctionality && actionableTask.ohCase.genericCaseType?.name)
        {
            return `${url}/genericCaseForm`;
        }

        return `${url}/matchedReferral`;
    }, [actionableTask, enableEnhancedInsufficientInformationFunctionality]);

    if (!actionableTask) {
        return null;
    }

    return (<Container>
        <Grid className="nomargintop">
            <Detail label="Case ID" value={actionableTask.ohCase.caseId ?? ""} labelWidth={5} valueWidth={11} />
            <Detail label="Employee First Name" value={actionableTask.ohCase.employeeFirstName ?? ""} labelWidth={5} valueWidth={11} />
            <Detail label="Employee Last Name" value={actionableTask.ohCase.employeeLastName ?? ""} labelWidth={5} valueWidth={11} />
            <Detail label="Case Type" value={actionableTask.ohCase.caseType ?? ""} labelWidth={5} valueWidth={11} />
            <Detail label="Case Status" value={actionableTask.ohCase.caseStatus ?? ""} labelWidth={5} valueWidth={11} />
            <Detail
                label="Date Referral Submitted"
                value={actionableTask.ohCase.referralSubmittedDate?.format("LLL") ?? ""}
                labelWidth={5}
                valueWidth={11}
            />
            <Grid.Row textAlign="right">
                <Grid.Column width={16}>
                    <a
                        href={viewReferralFormButtonUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Button content="View Referral Form" className="button" />
                    </a>
                </Grid.Column>
            </Grid.Row>
        </Grid>
        <Divider />
        {actionableTask.tasks && actionableTask.tasks.map(task => (
            <Grid className="insufficient-information-section" key={task.id}>
                <Detail
                    label="Action"
                    value="Insufficient Information provided in your referral please re-submit more information"
                    labelWidth={5}
                    valueWidth={11}
                />
                <Detail label="Notes from Clinical Team" value={task.notes} labelWidth={5} valueWidth={11} />
                <Detail
                    label="Date Further Information Requested"
                    value={Utils.DateTimeToString(task.dateCreated)}
                    labelWidth={5}
                    valueWidth={11}
                />
            </Grid>
        ))}
        <Divider />

        {actionableTask.tasks.some(t => !t.completed) && <InsufficientInformationActionForm />}
    </Container>);
};
